// 会社の評判コンポーネント用JavaScript
import './component.scss'
import '@splidejs/splide/css';
import { Splide } from '@splidejs/splide';
import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

import './images/reputation_icon.svg'

const app = Application.start()

app.register('refosumu-company-show-reputation', class extends Controller {
  static targets = ["sliderPc", "sliderSp"]

  connect() {
    // window.load イベントを待ってから初期化
    if (document.readyState === 'complete') {
      this.initializeSliders()
    } else {
      window.addEventListener('load', () => {
        this.initializeSliders()
      })
    }
  }

  initializeSliders() {
    const PC_PER_PAGE = 3;
    const SP_PER_PAGE = 1;

    // PC用スライダー初期化
    if (this.hasSliderPcTarget) {
      const pcSlides = this.sliderPcTarget.querySelectorAll('.splide__slide');
      const pcSlideCount = pcSlides.length;

      const pcConfig = {
        speed: 800,
        perPage: PC_PER_PAGE,
        perMove: PC_PER_PAGE,
        gap: '8px',
        pagination: false,
        arrows: pcSlideCount > PC_PER_PAGE, // 3件以下の場合はarrows非表示
      };

      const pcSplide = new Splide(this.sliderPcTarget, pcConfig);
      pcSplide.mount();
    }

    // SP用スライダー初期化
    if (this.hasSliderSpTarget) {
      const spSlides = this.sliderSpTarget.querySelectorAll('.splide__slide');
      const spSlideCount = spSlides.length;
      
      const spConfig = {
        speed: 800,
        perPage: SP_PER_PAGE,
        perMove: SP_PER_PAGE,
        gap: '12px',
        pagination: false,
        arrows: spSlideCount > SP_PER_PAGE, // 1件の場合はarrows非表示
        focus: 'center',
      };
      
      const spSplide = new Splide(this.sliderSpTarget, spConfig);
      spSplide.mount();
    }
  }
})
